import useId from '../utils/useId';
import * as React from 'react';
export const pulleySvg = React.forwardRef(function pulleySvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: `url(#bi_pulley__a_${id_0})`,
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.744 6.856a6.256 6.256 0 1 1 0 12.51h-3.872v5.957H9V6.857h7.744Zm-3.872 9.385h3.098a3.011 3.011 0 0 0 3.01-3.011v-.083a3.011 3.011 0 0 0-3.01-3.011h-3.098v6.105Z',
      fill: '#F2EDE0',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_pulley__a_${id_0}`,
          x1: 16,
          y1: 0,
          x2: 16,
          y2: 32,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#616D3B',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#DB6732',
        }),
      ),
    ),
  );
});
pulleySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var pulley = {
  category: 'brand',
  colorable: false,
  name: 'pulley',
  svg: pulleySvg,
};
